import { render } from "./SocialButtons.vue?vue&type=template&id=659855e0&scoped=true"
import script from "./SocialButtons.vue?vue&type=script&lang=js"
export * from "./SocialButtons.vue?vue&type=script&lang=js"

import "./SocialButtons.vue?vue&type=style&index=0&id=659855e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-659855e0"

export default script